export class Analytics {
  static trackNodeCreation(formData) {
    if (formData.get !== undefined) {
      const eventName = "automation-add-" + formData.get("node[kind]")
      analytics.track(eventName, {
        account_id: window.app.user.account_id,
        event_type: formData.get("node[type]"),
        automation_id: formData.get("node[workflow_id]"),
        number_of_nodes: Workflow.nodes().length
      })
    }
  }

  static trackNodeSelectedForEdit() {
    analytics.track("Clicked into Automation Node", {
      account_id: window.app.user.account_id,
      automation_id: Workflow.dataset.oid
    })
  }

  static trackStatus(state) {
    // `Workflow` is the <workflow-graph id="Workflow"> element the legacy views
    // render. The v2 builder reuses this header above its own React canvas and
    // renders no graph element, so there is no shape to read here.
    if (typeof Workflow === "undefined") return

    var nodeCount = 0
    const nodeProps = Workflow.nodes().reduce((hash, node) => {
      if (node.kind) {
        nodeCount += 1
        const key = `number_of_${node.kind}s`
        hash[key] = (hash[key] || 0) + 1
      }
      return hash
    }, {})

    window.analytics.track("Changed Automation Status", {
      account_id: window.app.user.account_id,
      automation_id: Workflow.dataset.oid,
      automation_status: state ? "Started" : "Paused",
      userId: window.app.user.id,
      email: window.app.user.email,
      number_of_entry_points: JSON.parse(Workflow.dataset.roots).length,
      number_of_nodes: nodeCount,
      ...nodeProps
    })
  }
}
